const state = {
    dataMaterial: {
        title:'',
        description:'',
        color:'',
        _id:undefined
    },
    bodyElements: [],
    name: '',
    description: '',
    orderElement: 0,
    blockSelected:false,
    positionsBlock: {},
    blockFree: false,
    endIndex: 0,
    constructor:false,
    aside: false
}

const getters = {
    getAside: (state) => {
        return state.aside;
    },
    getBodyElements: (state) => {
        console.log('bodyElements: ',state);
        return state.bodyElements;
    },
    getActualOrder: (state) => {
        return state.orderElement;
    },
    getFlagsAboutBlocks: (state) => {
        return {
            bS: state.blockSelected,
            bF: state.blockFree
        }
    },
    getPositionBlockSelected: (state) => {
        return state.positionsBlock;
    },
    forUpdate: (state) => {
        console.log('for update:: ',state);
        return state.dataMaterial['_id']
    },
    inConstruction: (state) => {return state.constructor},
    getTitleAndDesc: (state) => {return {
        title: state.dataMaterial.title,
        description: state.dataMaterial.description,
        color: state.dataMaterial.color
    }},
    getTitle: (state) => {return state.dataMaterial['title']},
    getDesc: (state) => {return state.dataMaterial['description']},
    getColor: (state) => {return state.dataMaterial['color']},
    getActivityData: (state) => {
        return  {
            info: state.dataMaterial,
            content: state.bodyElements
        }
    }
}

const mutations = {
    STATE_ASIDE(state, payload) {
        state.aside = payload;
    },
    ADD_ELEMENT(state, payload) {
        console.log(payload);
        // Asigna valor al index del elemento evaluando primero si tiene elementos el array y si es asi suma +1 al valor del index agregado en el ultimo elemento agregado
        payload.index = state.endIndex;
        state.endIndex ++;
        state.bodyElements.push(payload);
    },
    ADD_ELEMENT_IN_BLOCK(state,element){
        state.bodyElements[state.positionsBlock.iActivity]['columns'][state.positionsBlock.iColumn]['element'] = element;
        state.bodyElements[state.positionsBlock.iActivity]['columns'][state.positionsBlock.iColumn]['selected'] = false;
    },
    SET_DATA_MATERIAL(state,payload){
        for (var field in payload) {
            state.dataMaterial[field] = payload[field];
        }
    },
    REMOVE_ELEMENT(state,{ indexElement, indexColumn }) {
        if(indexColumn != null) state.bodyElements[indexElement]['columns'][indexColumn]['element'] = null;
        else state.bodyElements.splice(indexElement,1).map((el,i) => {el.index = i});
        if(state.blockSelected) {
            state.blockSelected = false;
            state.blockFree = false;
        }

    },
    SELECT_BLOCK(state, positions) {        
        state.blockSelected =  true;
        state.positionsBlock = positions;
        state.blockFree = true;
        console.log(state);
    },
    DESELECT_BLOCK(state) {
        state.blockSelected = false;
        state.positionsBlock = {};
        state.blockFree = false;
    }
    ,
    UPDATE_CONTENT_ELEMENT(state,{indexElement,data,field,indexColumns}) { //Actualizar dato de un elemento
        if(indexColumns != null) { // Cuando el elemento esta dentro de un elemento columna
            state.bodyElements[indexElement]['columns'][indexColumns]['element'][field] = data;
        } else state.bodyElements[indexElement][field] = data;
    },
    UPDATE_TITLE_DESC(state,payload) {
        if(payload.title) state.dataMaterial.title = payload.title;
        else if(payload.desc) state.dataMaterial.description = payload.desc;
        else if(payload.color) state.dataMaterial.color = payload.color;
    },
    UPDATE_ORDER_ELEMENTS(state,payload) {
        state.bodyElements = payload;
    },
    STATUS_CONSTRUCTION(state,status) {
        state.constructor = status;
    }

}

const actions = {
    insertElement(context, element) {
        context.commit('ADD_ELEMENT', element);
    },
    insertElementInBlock(context, element) {
        context.commit('ADD_ELEMENT_IN_BLOCK', element);
        context.commit('DESELECT_BLOCK');
    },
    dropElement({ commit }, indexes) {
        commit('REMOVE_ELEMENT', indexes);
    },
    selectBlock(context, indexBlock) {
        context.commit('SELECT_BLOCK', indexBlock);
    },
    deselectBlock(context) {
        context.commit('DESELECT_BLOCK');
    },
    toggleFreeBlocks(context) {
        context.commit('TOGGLE_FREE_BLOCKS');
    },
    updateContentElement({commit},data) {
        commit('UPDATE_CONTENT_ELEMENT',data);
    },
    updateOrders({commit},elements) {
        console.log("Updating orders: ", elements);
        commit('UPDATE_ORDER_ELEMENTS',elements);
    },
    updateTitleOrDesc({commit}, data) {
        commit('UPDATE_TITLE_DESC',data);
    },
    setInfo({commit}, data) {
        commit('SET_DATA_MATERIAL',data);
    },
    setStatusConstruction({commit},status) {
        commit('STATUS_CONSTRUCTION',status);
    },
    setAsideStatus({commit}, status) {
        commit('STATE_ASIDE', status);
    },
    clear() {
        state.dataMaterial = {
            title:'',
            description:'',
            color:'',
            _id:undefined
        },
        state.bodyElements = [],
        state.name = '',
        state.description = '',
        state.orderElement = 0,
        state.blockSelected = false,
        state.positionsBlock = {},
        state.blockFree = false,
        state.endIndex = 0,
        state.constructor = false
    }
}

export const constructor = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
